module.exports = new __parcel__URL__("createSpotlightImage.f64dc988.png").toString();